/**
 * Finds Mentions in a video comment or video comment reply.
 * Includes capture groups to extract all of the parts of a mention
 *
 * ex:
 * 'Test @[Yoann Jaspar](user:35)'.match(MENTION_MARKUP)
 * > [
 *     '@[Yoann Jaspar](user:35)',
 *     'Yoann Jaspar',
 *     '(user:35)',
 *     'user:35',
 *   ]
 */
export const MENTION_MARKUP = /@\[([^\]]+?)\](\(([^\)]+?)\))?/;

/**
 * Finds Mentions in a video comment or video comment reply.
 * Includes one capture group for the whole mention, and one
 * non-capturing group for an optional section.
 * ex:
 * 'Test @[Yoann Jaspar](user:35)'.match(MENTION_MARKUP)
 * > [
 *     '@[Yoann Jaspar](user:35)',
 *     '@[Yoann Jaspar](user:35)',
 *   ]
 */
export const MENTION_MARKUP_WHOLE = /(@\[[^\]]+?\](?:\([^\)]+?\))?)/;
